import { apiGetUserInfo } from '@/api/user';
import actions from '@/shared/actions';
import { setOnetrack } from '@/utils/onetrackStat.js';

/**
 * 获取用户信息的 hooks
 * @param router Vue Router 实例，用于登录失败时跳转
 * @returns 返回获取用户信息的函数和用户信息状态
 */
export function useUserInfo(router?: any) {
  /**
   * 获取用户信息并处理相关逻辑
   * @returns Promise<any> 成功返回用户信息对象，失败返回 false
   */
  const getUserInfo = async (): Promise<any> => {
    const res: any = await apiGetUserInfo();
    if (res.code === 0) {
      res.data.avatar =
        res.data.avatar ||
        'https://work.test.mi.com/retailrevolution-pc/img/user_icon.dcd7cc3b.png';
      let userInfo = res.data;

      setOnetrack(res.data);

      //用户信息存入setGlobalState供子项目使用
      actions.setGlobalState({ userInfo });

      return userInfo;
    } else {
      const redirect = encodeURI(window.location.href);
      setTimeout(() => {
        if (router) {
          router.push({
            name: 'login',
            query: { redirect: redirect }
          });
        } else {
          // 如果没有传入 router，则直接跳转
          window.location.href = `/login?redirect=${redirect}`;
        }
      }, 1000);
      return false;
    }
  };

  return {
    getUserInfo
  };
}
